import { Component, OnInit } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-skeleton-dqf-list',
    templateUrl: './skeleton-dqf-list.component.html',
    styleUrls: ['../dqf-list.component.scss', './skeleton-dqf-list.component.scss'],
    standalone: true,
    imports: [NgxSkeletonLoaderModule]
})
export class SkeletonDqfListComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
